<template>
  <div v-if="isShow">
    <header>
      好きな事・趣味を編集
      <div class="h-left">
        <a @click="$emit('close')"><img src="~@/assets/images/icon02.svg" /></a>
      </div>
    </header>
    <div id="wrap">
      <div class="txt-area">
        <p class="b">好きな事・趣味</p>
        <textarea v-model="formData.hobby" class="self-introduction1" placeholder="記入する" :maxlength="maxLength"></textarea
        >
        <div class="clearfix">
          <div class="self-introduction3">{{lengthContent}}/{{maxLength}}</div>
        </div>
      </div>

      <div :class="formData.hobby ? 'btn1' : 'btn3'"><a @click="$emit('submit', formData.hobby)">保存</a></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    value: String
  },
  emits: ['close'],
  data: () => ({
    formData: {
        hobby: null
    },
    maxLength: 100
  }),
  computed: {
    lengthContent() {
        if (this.formData.hobby)
            return this.formData.hobby.length
            
        return 0
    }
  },
  mounted() {
    this.formData.hobby = this.value
  },
  methods: {},
};
</script>